export default __webpack_public_path__ + "static/look-4-alt-1a6abe68b294ef5a9d5bb301054b4a1d.png";